import { connect } from 'react-redux';
import { singleFileUploadCancelAction, retryFilesUploadStartAction, getModalFileDataList, getUploadRetryableFailedFiles, isFileUploadModalRetryAllEnabled, getFileInfoState } from "../../file";
import { PhotoCaptureFileUploadProgressBar } from '../components/PhotoCaptureFileUploadProgressBar';
import { photoCaptureIsFileUploadStartedAction } from '../actions';
import { getPhotoCaptreIsFileUploadStarted } from '../selectors';
const mapStateToProps = (state, ownProps) => {
    var _a;
    const { byId, allIds } = getFileInfoState(state);
    return {
        uploadError: (_a = byId[allIds[0]]) === null || _a === void 0 ? void 0 : _a.uploadError,
        files: getModalFileDataList(state),
        errorMessage: ownProps.errorMessage,
        isFileUploadStarted: getPhotoCaptreIsFileUploadStarted(state),
        showRetryAll: isFileUploadModalRetryAllEnabled(state),
        uploadFailedFiles: getUploadRetryableFailedFiles(state)
    };
};
const mapDispatchToProps = (dispatch, ownProps) => ({
    onClose: () => {
        dispatch(photoCaptureIsFileUploadStartedAction(false));
    },
    onCancel: (id) => {
        dispatch(singleFileUploadCancelAction(id));
    },
    onRetryAll: (files) => {
        if (files.length > 0) {
            dispatch(retryFilesUploadStartAction(Object.assign({ files }, (ownProps.onRetryUploadComplete && { onAllFileUploadComplete: ownProps.onRetryUploadComplete }))));
        }
    }
});
const mergedProps = (stateProps, dispatchProps, ownProps) => {
    const { files, errorMessage, isFileUploadStarted, showRetryAll, uploadFailedFiles, uploadError } = stateProps;
    const { onClose, onCancel } = dispatchProps;
    const { linkTextColor, buttonBackgroundColor, buttonTextColor, children } = ownProps;
    return {
        linkTextColor,
        buttonBackgroundColor,
        buttonTextColor,
        children,
        files,
        errorMessage,
        uploadError,
        isFileUploadStarted,
        showRetryAll,
        onClose,
        onCancel,
        onRetryAll: () => dispatchProps.onRetryAll(uploadFailedFiles)
    };
};
export const ConnectedPhotoCaptureFileUploadProgressBar = connect(mapStateToProps, mapDispatchToProps, mergedProps)(PhotoCaptureFileUploadProgressBar);
//# sourceMappingURL=ConnectedPhotoCaptureFileUploadProgressBar.js.map